import React from "react";

import { OptionsType, ResponseType } from "commons/types/http";

import useHttpManaged from "hooks/useHttpManaged";

import { ApartmentKey, ApartmentRate, ApartmentRateBody } from "types/api/apartmentRates";

function useApartmentRatesApi() {
    const { get, put } = useHttpManaged();

    const getAllApartmentRates = React.useCallback(
        (options?: OptionsType): ResponseType<ApartmentRate[]> => {
            return get<undefined, undefined, ApartmentRate[]>({
                url: "/apartment-rates",
                options: options,
            });
        },
        [get],
    );

    const updateApartmentRate = React.useCallback(
        (apartment: ApartmentKey, body: ApartmentRateBody, options?: OptionsType): ResponseType<null> => {
            return put<{ apartment: ApartmentKey }, undefined, ApartmentRateBody, null>({
                url: "/apartment-rates/:apartment",
                pathParams: { apartment },
                body: body,
                options: options,
            });
        },
        [put],
    );

    return {
        getAllApartmentRates,
        updateApartmentRate,
    };
}

export default useApartmentRatesApi;
